module.exports = __webpack_public_path__ + "static/media/recoveryPassword.770c088e.png";